/* eslint-disable react/display-name, react/prop-types */

import React from 'react';
import { pickEnumProps } from 'utils/enum';
import { getDisplayName } from 'utils/react';
import assignHOCProps from './assignHOCProps';

export default function createWrapperHOC(WrapperComponent, WrappedComponent, props = {}) {
    const { propTypes = {}, defaultProps = {} } = WrappedComponent;
    const nameWrapped = getDisplayName(WrappedComponent);
    const nameWrapper = getDisplayName(WrapperComponent);

    const HOC = ({ containerRef, ...rest }) => (
        <WrapperComponent
            {...rest}
            {...props}
            ref={containerRef}
            wrappedComponent={WrappedComponent}
        />
    );

    return assignHOCProps(HOC, {
        displayName: `create${nameWrapper}(${nameWrapped})`,
        propTypes,
        defaultProps,
        enumProps: pickEnumProps(WrappedComponent),
    });
}
